export class Course {
    public id?: number;
    public name?: string;
    public displayName?: string;
    public countryCode?: string;
    public tag?: string;
    public isPlayerApp?: boolean;
}
